import { INPUT_TYPES } from '../utils/constants';
export default {
  title: 'Choose Best Group',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.groupSize > 1;
  },
  type: INPUT_TYPES.BOOLEAN,
  "default": true,
  description: "When true, the gallery will choose the best way to arrange the groups according\n  to the proportions of the items.\n  "
};